import React from 'react'
import {
    Card
} from "antd"
export default function BlankPage() {
    return (
        <Card>
            <h1>Blank Page</h1>
        </Card>
    )
}
